export default "__VITE_ASSET__0543cca4__"